import { Field } from "@/modules/FormTemplate/models/Field";
import { InfoGroupModel } from "@/modules/InfoGroup/models/InfoGroup";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { ListService } from "@/modules/List/services/ListService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  CONDITIONS_KEYS,
  DATA_TYPES,
  DATE_LABEL,
  DATE_OPERATOR_KEY_NAME_ARRAY,
  DELETE_DEEP_CONDITIONS,
  EQUAL_INCLUDES_OPERATORS_LIST,
  EQUAL_OPERATOR_KEY_NAME,
  FILTERS_NAMES_CONST,
  GENERAL_RULES_CONSTANTS,
  INCLUDES_OPERATOR_KEY_NAME,
  INFO_GROUPS,
  INPUT_TYPE,
  KEY_LIST,
  LIST_SAME_HANDLE_COLLECTIONS,
  SAME_OPERATOR_LIST_TYPES,
  SECOND_LEVEL,
  SELECT_TYPES,
  SET_INNER_CONDITIONS,
  SET_THIRD_LEVEL_INNER_CONDITIONS,
  STATES_ARRAY,
  THIRD_LEVEL
} from "../../constants/GeneralRulesConstants";
import { Collection } from "../../models/Collection.model";
import { InnerCondition } from "../../models/InnerConditions.model";
import { InnerConditionOperator } from "../../models/InnerConditionsOperator.model";
import InnerConditionComponent from "./components/InnerConditionComponent.vue";
import { ESCHEMA_TYPES } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import {
  FIELD_GROUP_CONSTANTS,
  INFO_GROUPS_ACCESS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { InnerConditionToDb } from "../../models/InnerConditionToDb.model";
import { AxiosError } from "axios";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { ServiceTemplateModel } from "@/modules/ServiceTemplate/models/ServiceTemplateModel";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";

ESCHEMA_TYPES.STRING;
@Component({
  name: "DeepLevelConditions",
  components: {
    InnerConditionComponent
  }
})
export default class DeepLevelConditions extends Vue {
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() listService!: ListService;

  @Prop() index!: number;
  @Prop() fields!: [];
  @Prop() collection!: Collection;
  @Prop() dataToEdit!: any[];
  @Prop({ default: () => ({}) }) dataToRefresh?: any[];
  @Prop() serviceTemplate!: ServiceTemplateModel;
  @Prop() propertyOfCollection!: string;

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  currentDisplayValue: any = "";
  accumulativeObjectArray: InnerCondition[] = [];
  accumulativeObjectArrayToUserCollection: InnerCondition[] = [];
  accumulativeObjectArrayToServiceCollection: InnerCondition[] = [];
  keyIterator = 1;
  setOfInnerAttributes: string[] = [];
  setOfThirdLevelInnerKeyAttributes: string[] = [];
  keyAttrFlag = "";
  operationAttrFlag = "";
  valueAttrFlag = "";
  infoGroupsFields: any = [];
  isInfoGroupsConditionsActivated = false;
  isGroupsServiceConditionsActivated = false;
  secondLevel: number = SECOND_LEVEL;
  thirdLevel: number = THIRD_LEVEL;
  initialObject: InnerCondition[] = [
    {
      key: "",
      operation: "",
      value: "",
      collection: this.collection,
      index: this.index,
      fields: this.fields,
      addBtn: false
    }
  ];
  levelCondition = 0;
  thirdLevelDeleteCounter = 1;
  sectionsGroupsThirdLevelEnable = false;

  async mounted() {
    if (
      this.propertyOfCollection === GENERAL_RULES_CONSTANTS.SERVICIO &&
      this.collection.key === FILTERS_NAMES_CONST.FORM.KEY
    ) {
      this.initialObject[0].addBtn = false;
    }

    if (
      this.dataToEdit.length > 0 &&
      LIST_SAME_HANDLE_COLLECTIONS.includes(this.collection.key)
    ) {
      this.accumulativeObjectArray = this.dataToEdit.map((data, index) => {
        if (this.dataToEdit.length - 1 === index) {
          return {
            key: data.key,
            operation: data.operation,
            value: data.value,
            collection: this.collection,
            index: this.index,
            fields: this.fields,
            addBtn: true
          };
        }
        return {
          key: data.key,
          operation: data.operation,
          value: data.value,
          collection: this.collection,
          index: this.index,
          fields: this.fields,
          addBtn: false
        };
      });

      if (this.collection.key === FILTERS_NAMES_CONST.FORM.KEY) {
        this.setLevels();
        this.sectionsGroupsThirdLevelEnable = true;
      }
    } else if (
      (this.dataToEdit.length > 0 &&
        this.collection.key === FILTERS_NAMES_CONST.USER.KEY) ||
      ((this.dataToRefresh ?? []).length > 0 &&
        this.dataToRefresh?.some(data => data.innerConditions.length > 0))
    ) {
      let arrayToIterate: InnerConditionToDb[] = [];

      if (
        (this.dataToRefresh ?? [])?.length > 0 &&
        this.dataToEdit.length === 0
      ) {
        this.dataToRefresh?.forEach(data => {
          arrayToIterate = [
            ...arrayToIterate,
            ...(data.innerConditions as InnerConditionToDb[])
          ];
        });
      } else {
        arrayToIterate = this.dataToEdit;
      }

      const secondLevelConditions = arrayToIterate.filter(
        each => each.level === SECOND_LEVEL
      );
      const thirdLevelConditions = arrayToIterate.filter(
        each => each.level === THIRD_LEVEL
      );
      this.accumulativeObjectArray = secondLevelConditions.map(condition => ({
        key: condition.key,
        operation: condition.operation,
        value: condition.value,
        collection: this.collection,
        index: this.index,
        fields: this.fields,
        addBtn: false
      }));

      this.infoGroupsFields = await this.getFieldsFromInfoGroupById(
        this.accumulativeObjectArray[0].value
      );

      this.accumulativeObjectArrayToUserCollection = thirdLevelConditions.map(
        (condition, index) => {
          if (thirdLevelConditions.length - 1 === index) {
            return {
              key: condition.key,
              operation: condition.operation,
              value: condition.value,
              collection: this.collection,
              index: this.index,
              fields: this.infoGroupsFields,
              addBtn: true
            };
          } else {
            return {
              key: condition.key,
              operation: condition.operation,
              value: condition.value,
              collection: this.collection,
              index: this.index,
              fields: this.infoGroupsFields,
              addBtn: false
            };
          }
        }
      );
      this.isInfoGroupsConditionsActivated = true;
    } else {
      this.accumulativeObjectArray = this.initialObject.map(item => {
        const newItem = Object.assign({}, item);
        return newItem;
      });
    }
  }

  setLevels() {
    let arrayToIterate: InnerConditionToDb[] = [];

    if (
      (this.dataToRefresh ?? [])?.length > 0 &&
      this.dataToEdit.length === 0
    ) {
      this.dataToRefresh?.forEach(data => {
        arrayToIterate = [
          ...arrayToIterate,
          ...(data.innerConditions as InnerConditionToDb[])
        ];
      });
    } else {
      arrayToIterate = this.dataToEdit;
    }

    const secondLevelConditions = arrayToIterate.filter(
      each => each.level === SECOND_LEVEL
    );
    const thirdLevelConditions = arrayToIterate.filter(
      each => each.level === THIRD_LEVEL
    );
    this.accumulativeObjectArray = secondLevelConditions.map(condition => ({
      key: condition.key,
      operation: condition.operation,
      value: condition.value,
      collection: this.collection,
      index: this.index,
      fields: this.fields,
      addBtn: false
    }));

    thirdLevelConditions.forEach((condition, index) => {
      this.serviceThirdLevel(
        {
          key: "",
          operation: "",
          value: "",
          collection: this.collection,
          index: this.index,
          fields: []
        },
        this.accumulativeObjectArray[index].value,
        condition.operation,
        condition.key,
        condition.value
      );
    });
  }

  deleteConditionIndex(index: number, indexMacro: number) {
    const accumulativeArray: any[] = JSON.parse(
      JSON.stringify(this.accumulativeObjectArray)
    );
    if (accumulativeArray.length > 1) {
      this.accumulativeObjectArray.splice(index, 1);
      if (this.accumulativeObjectArray.length > 0) {
        this.accumulativeObjectArray = this.btnStatusInElimination(
          this.accumulativeObjectArray
        );
      }
    } else {
      this.$emit(DELETE_DEEP_CONDITIONS, this.index);
      this.accumulativeObjectArray.splice(index, 1);
    }
    this.keyIterator++;
    this.keyAttributesAlreadySet();
    this.$emit(SET_INNER_CONDITIONS, this.accumulativeObjectArray, indexMacro);
  }

  deleteConditionIndexToUsers(
    index: number,
    level: number,
    indexMacro: number
  ) {
    if (level === SECOND_LEVEL) {
      this.deleteConditionIndex(index, indexMacro);
      this.accumulativeObjectArrayToUserCollection = [];
    } else {
      const accumulativeArray: InnerCondition[] = JSON.parse(
        JSON.stringify(this.accumulativeObjectArrayToUserCollection)
      );
      if (accumulativeArray.length >= 1) {
        this.accumulativeObjectArrayToUserCollection.splice(index, 1);
        if (this.accumulativeObjectArrayToUserCollection.length > 0) {
          this.accumulativeObjectArrayToUserCollection = this.btnStatusInElimination(
            this.accumulativeObjectArrayToUserCollection
          );
          this.accumulativeObjectArrayToUserCollection = this.accumulativeObjectArrayToUserCollection.map(
            (element, index) => ({
              ...element,
              index
            })
          );
        }
      }
      if (this.accumulativeObjectArrayToUserCollection.length === 0) {
        this.isInfoGroupsConditionsActivated = false;
        this.accumulativeObjectArray[0].addBtn = true;
      }
      this.keyAttributesAlreadySetInUsers();
      this.thirdLevelDeleteCounter++;
    }
    this.$emit(
      SET_THIRD_LEVEL_INNER_CONDITIONS,
      this.accumulativeObjectArrayToUserCollection,
      indexMacro
    );
    this.$emit(SET_INNER_CONDITIONS, this.accumulativeObjectArray, indexMacro);
  }

  deleteSessionGroupsConditions(
    index: number,
    level: number,
    indexMacro: number
  ) {
    if (level === SECOND_LEVEL) {
      this.deleteConditionIndex(index, indexMacro);
      this.accumulativeObjectArrayToServiceCollection = [];
    } else {
      const accumulativeArray: InnerCondition[] = JSON.parse(
        JSON.stringify(this.accumulativeObjectArrayToServiceCollection)
      );
      if (accumulativeArray.length >= 1) {
        this.accumulativeObjectArrayToServiceCollection.splice(index, 1);
        if (this.accumulativeObjectArrayToServiceCollection.length > 0) {
          this.accumulativeObjectArrayToServiceCollection = this.btnStatusInElimination(
            this.accumulativeObjectArrayToServiceCollection
          );
          this.accumulativeObjectArrayToServiceCollection = this.accumulativeObjectArrayToServiceCollection.map(
            (element, index) => ({
              ...element,
              index
            })
          );
        }
      }
      if (this.accumulativeObjectArrayToServiceCollection.length === 0) {
        this.sectionsGroupsThirdLevelEnable = false;
        this.accumulativeObjectArray[0].addBtn = true;
      }
      this.keyAttributesAlreadySetInForms();
      this.thirdLevelDeleteCounter++;
    }
    this.$emit(
      SET_THIRD_LEVEL_INNER_CONDITIONS,
      this.accumulativeObjectArrayToServiceCollection,
      indexMacro
    );
    this.$emit(SET_INNER_CONDITIONS, this.accumulativeObjectArray, indexMacro);
  }

  btnStatusInElimination(objArray: InnerCondition[]) {
    const objArrayLength = objArray.length;
    return objArray.map((obj, index) => {
      if (index < objArrayLength - 1) {
        return {
          ...obj,
          addBtn: false
        };
      }
      return {
        ...obj,
        addBtn: true
      };
    });
  }

  addInnerConditionToAccumulator(innerValue: InnerCondition) {
    if (
      this.collection.key === FILTERS_NAMES_CONST.USER.KEY &&
      this.accumulativeObjectArray.length === 1 &&
      this.accumulativeObjectArray[0].key === INFO_GROUPS
    ) {
      this.isInfoGroupsConditionsActivated = true;
      innerValue = {
        ...innerValue,
        fields: this.infoGroupsFields
      };
      this.accumulativeObjectArray[0].addBtn = false;
      Vue.set(
        this.accumulativeObjectArrayToUserCollection,
        this.accumulativeObjectArrayToUserCollection.length,
        innerValue
      );
      this.keyAttributesAlreadySetInUsers();
      this.accumulativeObjectArrayToUserCollection = this.accumulativeObjectArrayToUserCollection.map(
        (object, index) => {
          if (
            index + 1 ===
            this.accumulativeObjectArrayToUserCollection.length
          ) {
            return {
              ...object,
              addBtn: true,
              condition: this.index
            };
          }
          return {
            ...object,
            addBtn: false,
            condition: this.index
          };
        }
      );
    } else if (
      this.collection.key === FILTERS_NAMES_CONST.FORM.KEY &&
      this.accumulativeObjectArray.length === 1 &&
      this.accumulativeObjectArray[0].key === GENERAL_RULES_CONSTANTS.GROUPS
    ) {
      this.serviceThirdLevel(innerValue);
    } else {
      Vue.set(
        this.accumulativeObjectArray,
        this.accumulativeObjectArray.length,
        innerValue
      );
      this.keyAttributesAlreadySet();
      this.accumulativeObjectArray = this.accumulativeObjectArray.map(
        (object, index) => {
          if (index + 1 === this.accumulativeObjectArray.length) {
            return {
              ...object,
              addBtn: true,
              condition: this.index
            };
          }
          return {
            ...object,
            addBtn: false,
            condition: this.index
          };
        }
      );
    }
  }

  serviceThirdLevel(
    innerValue: InnerCondition,
    keySecondLevel?: string,
    operation?: string,
    keyThirdLevel?: string,
    valueThirdLevel?: string
  ) {
    const group = this.serviceTemplate.groups?.find(
      group =>
        group.key === (keySecondLevel ? keySecondLevel : this.valueAttrFlag)
    );
    this.sectionsGroupsThirdLevelEnable = true;
    const sessions = group
      ? (group.sessions as SectionGroupDetail[]).map(session => ({
          key: session.id,
          name: session.name
        }))
      : [];
    const fieldsThirdLevel = [
      {
        from: FILTERS_NAMES_CONST.SERVICE.KEY,
        display: INPUT_TYPE.SELECT,
        key: FILTERS_NAMES_CONST.SESSION.KEY,
        value: GENERAL_RULES_CONSTANTS.SESSIONES,
        valueList: sessions,
        operatorList: [EQUAL_OPERATOR_KEY_NAME, INCLUDES_OPERATOR_KEY_NAME]
      }
    ];

    innerValue = {
      ...innerValue,
      fields: group ? fieldsThirdLevel : []
    };
    this.accumulativeObjectArray[0].addBtn = false;
    Vue.set(
      this.accumulativeObjectArrayToServiceCollection,
      this.accumulativeObjectArrayToServiceCollection.length,
      innerValue
    );
    this.setOfThirdLevelInnerKeyAttributes = this.accumulativeObjectArrayToServiceCollection.map(
      accumulativeObject => accumulativeObject.key
    );
    this.accumulativeObjectArrayToServiceCollection = this.accumulativeObjectArrayToServiceCollection.map(
      (object, index) => {
        if (
          index + 1 ===
          this.accumulativeObjectArrayToServiceCollection.length
        ) {
          return {
            ...object,
            addBtn: false,
            operation: operation ?? "",
            key: keyThirdLevel ?? "",
            condition: this.index,
            value: valueThirdLevel ?? ""
          };
        }
        return {
          ...object,
          addBtn: false,
          operation: operation ?? "",
          key: keyThirdLevel ?? "",
          condition: this.index,
          value: valueThirdLevel ?? ""
        };
      }
    );
  }

  async getFieldsFromInfoGroupById(infoGroupById: string) {
    try {
      const {
        code,
        data,
        message
      } = await this.infoGroupService.getInfoGroupById(infoGroupById);
      if (code === Http.Found) {
        const fields = (data as InfoGroupModel).fields;
        const fieldsByVisualElement =
          fields.length > 0
            ? await Promise.all(
                fields?.map(async field => {
                  const fieldValue = field as Field;
                  let display = "";
                  let value: any[] = [];

                  if (Object.keys(field).includes(KEY_LIST) && field.list) {
                    display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                    const listInfo = (
                      await this.listService.getListById(field.list)
                    ).data?.options;
                    value = listInfo ?? [];
                  } else if (
                    ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                    fieldValue.schema.format === DATE_LABEL
                  ) {
                    display = INPUT_TYPE.DATE_PICKER;
                  } else if (
                    ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                    fieldValue.schema.type === ESCHEMA_TYPES.STRING
                  ) {
                    display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.INPUT;
                  } else if (
                    FIELD_GROUP_CONSTANTS.FIELD_TYPE.SLIDER ===
                      fieldValue.visualElement ||
                    fieldValue.visualElement === INPUT_TYPE.PHONE ||
                    (ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                      fieldValue.schema.type === INPUT_TYPE.INTEGER)
                  ) {
                    display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER;
                  } else if (
                    FIELD_GROUP_CONSTANTS.FIELD_TYPE.SWITCH ===
                    fieldValue.visualElement
                  ) {
                    display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                    value = STATES_ARRAY;
                  } else if (SELECT_TYPES.includes(fieldValue.visualElement)) {
                    display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                    value =
                      (fieldValue.visualElement ===
                      FIELD_GROUP_CONSTANTS.FIELD_TYPE.RADIO
                        ? fieldValue.schema.enum
                        : fieldValue.schema.items?.enum) ?? [];
                  }
                  value = value.map(item => {
                    if (typeof item === DATA_TYPES.STRING) {
                      return {
                        key: item,
                        name: item
                      };
                    } else {
                      return {
                        key: !item.value ? item.title : item.value,
                        name: item.title as string
                      };
                    }
                  });

                  let operatorValues: InnerConditionOperator[] = [];

                  if (display === INPUT_TYPE.DATE_PICKER) {
                    operatorValues = DATE_OPERATOR_KEY_NAME_ARRAY;
                  } else if (!SAME_OPERATOR_LIST_TYPES.includes(display)) {
                    operatorValues = EQUAL_INCLUDES_OPERATORS_LIST;
                  } else {
                    operatorValues = [EQUAL_OPERATOR_KEY_NAME];
                  }

                  return {
                    from: FILTERS_NAMES_CONST.FORM.KEY,
                    key: field.conversationTitle ?? field.schema.title,
                    value: field.conversationTitle ?? field.schema.title,
                    display,
                    valueList: value,
                    operatorList: operatorValues
                  };
                })
              )
            : [];

        return fieldsByVisualElement;
      } else if (code === Http.NotFound) {
        return [];
      } else {
        throw new Error(message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(error as string);
    }
  }

  keyAttributesAlreadySet() {
    this.setOfInnerAttributes = this.accumulativeObjectArray.map(
      accumulativeObject => accumulativeObject.key
    );
  }

  keyAttributesAlreadySetInUsers() {
    this.setOfThirdLevelInnerKeyAttributes = this.accumulativeObjectArrayToUserCollection.map(
      accumulativeObject => accumulativeObject.key
    );
  }

  keyAttributesAlreadySetInForms() {
    this.setOfThirdLevelInnerKeyAttributes = this.accumulativeObjectArrayToServiceCollection.map(
      accumulativeObject => accumulativeObject.key
    );
  }

  @Watch("valueAttrFlag")
  async changeValueAttr() {
    const flagObject = { ...this.accumulativeObjectArray[0] };
    if (Array.isArray(flagObject.value)) {
      if (flagObject.value.length > 1) return;
      flagObject.value = flagObject.value.toString();
    }

    if (
      flagObject.key === INFO_GROUPS &&
      flagObject.value &&
      this.levelCondition === this.secondLevel
    ) {
      if (
        this.currentDisplayValue &&
        flagObject.value !== this.currentDisplayValue
      ) {
        this.accumulativeObjectArrayToUserCollection = [];
        this.accumulativeObjectArrayToServiceCollection = [];
        this.accumulativeObjectArray[0].addBtn = true;
      }
      this.infoGroupsFields = await this.getFieldsFromInfoGroupById(
        flagObject.value
      );
      this.currentDisplayValue = flagObject.value;
    }
    if (
      flagObject.key === GENERAL_RULES_CONSTANTS.GROUPS &&
      flagObject.value &&
      flagObject.operation === EQUAL_OPERATOR_KEY_NAME.key &&
      this.levelCondition === this.secondLevel
    ) {
      if (
        this.currentDisplayValue &&
        flagObject.value !== this.currentDisplayValue
      ) {
        this.accumulativeObjectArrayToServiceCollection = [];
        this.accumulativeObjectArray[0].addBtn = true;
      }
      this.currentDisplayValue = flagObject.value;
    }
  }

  modifyKey(
    keyAttrValue: string,
    indexMacro: number,
    indexLocal: number,
    level: number
  ) {
    this.levelCondition = level;
    this.keyAttrFlag = keyAttrValue;
    if (level === SECOND_LEVEL && this.accumulativeObjectArray[indexLocal]) {
      this.accumulativeObjectArray[indexLocal].key = keyAttrValue;
      this.accumulativeObjectArray[indexLocal].index = indexLocal;
      this.$emit(
        SET_INNER_CONDITIONS,
        this.accumulativeObjectArray,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToUserCollection[indexLocal]
    ) {
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].key = keyAttrValue;
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].index = indexLocal;
      this.$emit(
        SET_THIRD_LEVEL_INNER_CONDITIONS,
        this.accumulativeObjectArrayToUserCollection,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToServiceCollection[indexLocal]
    ) {
      this.setInnerConditionThirdLevel(
        this.accumulativeObjectArrayToServiceCollection,
        indexLocal,
        indexMacro,
        keyAttrValue,
        GENERAL_RULES_CONSTANTS.KEY
      );
    }
    this.keyAttributesAlreadySet();
  }

  modifyOps(
    opAttrAttrValue: string,
    indexMacro: number,
    indexLocal: number,
    level: number
  ) {
    this.levelCondition = level;
    if (opAttrAttrValue && level === SECOND_LEVEL) {
      this.accumulativeObjectArray = this.accumulativeObjectArray.map(
        (acc, index) => {
          if (index === this.accumulativeObjectArray.length - 1) {
            return {
              ...acc,
              addBtn: true
            };
          }
          return {
            ...acc,
            addBtn: false
          };
        }
      );
    }

    if (level === SECOND_LEVEL)
      this.accumulativeObjectArrayToUserCollection = [];

    if (level === THIRD_LEVEL) {
      this.accumulativeObjectArray = this.accumulativeObjectArray.map(acc => {
        return {
          ...acc,
          addBtn: false
        };
      });
    }

    this.operationAttrFlag = opAttrAttrValue;
    if (level === SECOND_LEVEL && this.accumulativeObjectArray[indexLocal]) {
      this.accumulativeObjectArray[indexLocal].operation = opAttrAttrValue;
      this.accumulativeObjectArray[indexLocal].index = indexLocal;
      this.$emit(
        SET_INNER_CONDITIONS,
        this.accumulativeObjectArray,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToUserCollection[indexLocal]
    ) {
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].operation = opAttrAttrValue;
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].index = indexLocal;
      this.$emit(
        SET_THIRD_LEVEL_INNER_CONDITIONS,
        this.accumulativeObjectArrayToUserCollection,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToServiceCollection[indexLocal]
    ) {
      this.setInnerConditionThirdLevel(
        this.accumulativeObjectArrayToServiceCollection,
        indexLocal,
        indexMacro,
        opAttrAttrValue,
        CONDITIONS_KEYS[1]
      );
    }
  }

  modifyValue(
    dataAttrValue: any,
    indexMacro: number,
    indexLocal: number,
    level: number
  ) {
    this.levelCondition = level;
    this.valueAttrFlag = dataAttrValue;
    if (level === SECOND_LEVEL && this.accumulativeObjectArray[indexLocal]) {
      this.accumulativeObjectArray[indexLocal].value = dataAttrValue;
      this.accumulativeObjectArray[indexLocal].index = indexLocal;
      this.$emit(
        SET_INNER_CONDITIONS,
        this.accumulativeObjectArray,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToUserCollection[indexLocal]
    ) {
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].value = dataAttrValue;
      this.accumulativeObjectArrayToUserCollection[
        indexLocal
      ].index = indexLocal;
      this.$emit(
        SET_THIRD_LEVEL_INNER_CONDITIONS,
        this.accumulativeObjectArrayToUserCollection,
        indexMacro
      );
    } else if (
      level === THIRD_LEVEL &&
      this.accumulativeObjectArrayToServiceCollection[indexLocal]
    ) {
      this.setInnerConditionThirdLevel(
        this.accumulativeObjectArrayToServiceCollection,
        indexLocal,
        indexMacro,
        dataAttrValue,
        CONDITIONS_KEYS[2]
      );
    }
  }

  setInnerConditionThirdLevel(
    accumulativeArray: InnerCondition[],
    indexLocal: number,
    indexMacro: number,
    value: string,
    property: string
  ) {
    if (property !== "key" && property !== "operation" && property !== "value")
      return;

    accumulativeArray[indexLocal][property] = value;
    accumulativeArray[indexLocal].index = indexLocal;
    this.$emit(SET_THIRD_LEVEL_INNER_CONDITIONS, accumulativeArray, indexMacro);
  }
}
